module.exports = __webpack_public_path__ + "static/media/54.2f434964.png";